/** 盤面の各軸のサイズ（10×10×10 = 1000 マス） */
export const BOARD_SIZE = 10;
export const BOARD_CELLS = BOARD_SIZE * BOARD_SIZE * BOARD_SIZE;

/**
 * ゲームロジックと 3D 表示で共通のマス索引。
 * x が最も速く変動する: index = x + y*10 + z*100
 */
export function cellIndex(x: number, y: number, z: number): number {
  return x + y * BOARD_SIZE + z * BOARD_SIZE * BOARD_SIZE;
}

export function indexOfX(index: number): number {
  return index % BOARD_SIZE;
}

export function indexOfY(index: number): number {
  return Math.floor(index / BOARD_SIZE) % BOARD_SIZE;
}

export function indexOfZ(index: number): number {
  return Math.floor(index / (BOARD_SIZE * BOARD_SIZE));
}

export function inBounds(x: number, y: number, z: number): boolean {
  return (
    Number.isInteger(x) &&
    Number.isInteger(y) &&
    Number.isInteger(z) &&
    x >= 0 &&
    x < BOARD_SIZE &&
    y >= 0 &&
    y < BOARD_SIZE &&
    z >= 0 &&
    z < BOARD_SIZE
  );
}
